import React from "react";
import { Link } from "gatsby";

const Pagination = ({ pageContext }) => {
  const { currentPage, numPages, articleCount } = pageContext;

  /* const isFirst = currentPage === 1;
    const isLast = currentPage === numPages; */
  const prevPage = currentPage - 1 === 1 ? "/" : (currentPage - 1).toString();
  const nextPage = (currentPage + 1).toString();

  if (articleCount < 6) {
    return ``;
  } else {
    return (
      <div className=" text-xs pb-16 w-3/4 mx-auto  flex justify-center">
        <Link
          aria-disabled={prevPage < 1}
          className="pagination-prev pagination-box mr-4"
          to={prevPage}
        >
          <span>←</span> <span className="hidden sm:inline">Anterior</span>
        </Link>
        <span className="pagination-current pagination-box mr-4">
          Página {currentPage} de {numPages}
        </span>
        <span className="pagination-count pagination-box mr-4">
          Total artículos: {articleCount}
        </span>
        <Link
          className=" pagination-next pagination-box mr-4"
          to={nextPage}
          aria-disabled={nextPage > numPages}
        >
          <span className="hidden sm:inline">Siguiente </span>
          <span>→</span>
        </Link>
      </div>
    );
  }
};

export default Pagination;
